import Vue from 'vue';
export default new Vue();


// WEBPACK FOOTER //
// ./src/modules/web/api/bus.js